import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";
import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchGenericPageData } from "lib/fetchers/genericPage";
import type { GenericPageData } from "lib/fetchers/genericPage";

import GenericPageView from "content-ui/genericPages/index";
import ErrorBoundary from "components/errorBoundary/errorBoundary";

const PAGE_SLUG = "events-delegate-terms-and-conditions";

export async function getStaticProps({ preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchGenericPageData({ pageSlug: PAGE_SLUG, preview }),
  ]);

  return {
    props: {
      dato,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  dato: GenericPageData;
};

const EventsDelegateTermsAndConditionsPage = (props: PageProps) => {
  const { title, description, image } = props?.dato?.seo || {};

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/events-delegate-terms-and-conditions"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: image?.url }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <GenericPageView {...props.dato} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default EventsDelegateTermsAndConditionsPage;
